
const imageData = [
  {
    path: require('./assets/001.jpg'), 
    rarity: 1,
    score: 1,
    text: 'Aiko Tanaka',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: '0xMQQ Intern',
    Religiouspersuasion: 'Phallusophical',
    Codename: 'Curious Hamster',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/002.jpg'),
rarity: 2,
    score: 2,
    text: 'Carlos Mendes',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brave Lizard',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/003.jpg'),
rarity: 3,
    score: 3,
    text: 'Priya Patel',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Crazy Eagle',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/004.jpg'),
rarity: 4,
    score: 4,
    text: 'Mamadou Diallo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Danger Dancer',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/005.jpg'),
rarity: 5,
    score: 5,
    text: 'Nina Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Fearless Unicorn',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/006.jpg'),
rarity: 6,
    score: 6,
    text: 'Javier López',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brown Lightning',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/007.jpg'),
rarity: 7,
    score: 7,
    text: 'Emily Johnson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Visible Ghost',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/008.jpg'),
rarity: 8,
    score: 8,
    text: 'Fatima Zayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Neon Hunter',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/009.jpg'),
rarity: 9,
    score: 9,
    text: 'Elias Gustavsson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Dizzy Wolf',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/010.jpg'),
rarity: 10,
    score: 10,
    text: 'Isabella Rossi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Linda',
    Codename: 'Night Trapper',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/011.jpg'),
rarity: 11,
    score: 11,
    text: 'Luka Jovanović',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/012.jpg'),
rarity: 12,
    score: 12,
    text: 'Rana El-Masry',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/013.jpg'),
rarity: 13,
    score: 13,
    text: 'Hans Müller',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'One eyed',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/014.jpg'),
rarity: 14,
    score: 14,
    text: 'Amira Abdi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Curious Hamster',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/015.jpg'),
rarity: 15,
    score: 15,
    text: 'Akira Yamamoto',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/016.jpg'),
rarity: 16,
    score: 16,
    text: 'Jasmine Nguyen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/017.jpg'),
rarity: 17,
    score: 17,
    text: 'Ahmed Hussain',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/018.jpg'),
rarity: 18,
    score: 18,
    text: 'Sara Nowak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Fearless Unicorn',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/019.jpg'),
rarity: 19,
    score: 19,
    text: 'Dmitri Petrov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brown Lightning',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/020.jpg'),
rarity: 20,
    score: 20,
    text: 'Samuel Brown',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Visible Ghost',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/021.jpg'),
rarity: 21,
    score: 21,
    text: 'Rui Almeida',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/022.jpg'),
rarity: 22,
    score: 22,
    text: 'Sofia Andersson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Dizzy Wolf',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/023.jpg'),
rarity: 23,
    score: 23,
    text: 'Miguel Torres',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/024.jpg'),
rarity: 24,
    score: 24,
    text: 'Nia Jones',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/025.jpg'),
rarity: 25,
    score: 25,
    text: 'Chin Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/026.jpg'),
rarity: 26,
    score: 26,
    text: 'Marisol Ortiz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/027.jpg'),
rarity: 27,
    score: 27,
    text: 'Pavel Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/028.jpg'),
rarity: 28,
    score: 28,
    text: 'Kiara Smith',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/029.jpg'),
rarity: 29,
    score: 29,
    text: 'Tariq Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Crazy Eagle',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/030.jpg'),
rarity: 30,
    score: 30,
    text: 'Rosa Fernández',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/031.jpg'),
rarity: 31,
    score: 31,
    text: 'Hiroshi Nakamura',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/032.jpg'),
rarity: 32,
    score: 32,
    text: 'Mariam Othman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/033.jpg'),
rarity: 33,
    score: 33,
    text: 'Liam Murphy',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/034.jpg'),
rarity: 34,
    score: 34,
    text: 'Tenzin Wangchuk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/035.jpg'),
rarity: 35,
    score: 35,
    text: 'Anna Kowalski',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/036.jpg'),
rarity: 36,
    score: 36,
    text: 'Zhen Zhu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/037.jpg'),
rarity: 37,
    score: 37,
    text: 'Josefina Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/038.jpg'),
rarity: 38,
    score: 38,
    text: 'Vincent Dubois',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/039.jpg'),
rarity: 39,
    score: 39,
    text: 'Mohammed Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/040.jpg'),
rarity: 40,
    score: 40,
    text: 'Elena Grigoreva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/041.jpg'),
rarity: 41,
    score: 41,
    text: 'Carlos García',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/042.jpg'),
rarity: 42,
    score: 42,
    text: 'Darius Walker',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/043.jpg'),
rarity: 43,
    score: 43,
    text: 'Amina Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/044.jpg'),
rarity: 44,
    score: 44,
    text: 'Khalid Aziz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/045.jpg'),
rarity: 45,
    score: 45,
    text: 'Yuna Park',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/046.jpg'),
rarity: 46,
    score: 46,
    text: 'Laura Thompson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/047.jpg'),
rarity: 47,
    score: 47,
    text: 'Enrique Sánchez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/048.jpg'),
rarity: 48,
    score: 48,
    text: 'Aaliyah Jones',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/049.jpg'),
rarity: 49,
    score: 49,
    text: 'Yukiko Suzuki',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/050.jpg'),
rarity: 50,
    score: 50,
    text: 'Leila Ben Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/051.jpg'),
rarity: 51,
    score: 51,
    text: 'Sven Andersen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/052.jpg'),
rarity: 52,
    score: 52,
    text: 'Luis Martins',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/053.jpg'),
rarity: 53,
    score: 53,
    text: 'Mei Zhang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/054.jpg'),
rarity: 54,
    score: 54,
    text: 'Petra Novak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/055.jpg'),
rarity: 55,
    score: 55,
    text: 'Aditya Singh',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/056.jpg'),
rarity: 56,
    score: 56,
    text: 'Kaori Sato',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/057.jpg'),
rarity: 57,
    score: 57,
    text: 'Luiz Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/058.jpg'),
rarity: 58,
    score: 58,
    text: 'Omar Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/059.jpg'),
rarity: 59,
    score: 59,
    text: 'Angelina Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/060.jpg'),
rarity: 60,
    score: 60,
    text: 'Tomasz Kwiatkowski',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Linda',
    Codename: 'Neon Hunter',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/061.jpg'),
rarity: 61,
    score: 61,
    text: 'Maria Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Dizzy Wolf',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/062.jpg'),
rarity: 62,
    score: 62,
    text: 'Reza Amini',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/063.jpg'),
rarity: 63,
    score: 63,
    text: 'Sandra Müller',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'All Thumbs',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/064.jpg'),
rarity: 64,
    score: 64,
    text: 'Ali Shah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Lopside Sack',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/065.jpg'),
rarity: 65,
    score: 65,
    text: 'Paola Rizzo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/066.jpg'),
rarity: 66,
    score: 66,
    text: 'Gabriel Santos',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Curious Hamster',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/067.jpg'),
rarity: 67,
    score: 67,
    text: 'Daisy Roberts',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/068.jpg'),
rarity: 68,
    score: 68,
    text: 'Anders Svensson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/069.jpg'),
rarity: 69,
    score: 69,
    text: 'Linh Pham',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/070.jpg'),
rarity: 70,
    score: 70,
    text: 'Gabriela Silva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/071.jpg'),
rarity: 71,
    score: 71,
    text: 'Ahmad Mustafa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Brown Lightning',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/072.jpg'),
rarity: 72,
    score: 72,
    text: 'Mia Chang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/073.jpg'),
rarity: 73,
    score: 73,
    text: 'Pablo Gómez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'Neon Hunter',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/074.jpg'),
rarity: 74,
    score: 74,
    text: 'Sakura Tanaka',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Dizzy Wolf',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/075.jpg'),
rarity: 75,
    score: 75,
    text: 'Lina Haddad',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/076.jpg'),
rarity: 76,
    score: 76,
    text: 'Eero Virtanen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'All Thumbs',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/077.jpg'),
rarity: 77,
    score: 77,
    text: 'Ravi Kumar',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Lopside Sack',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/078.jpg'),
rarity: 78,
    score: 78,
    text: 'Katarina Horvat',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/079.jpg'),
rarity: 79,
    score: 79,
    text: 'Fawaz Al-Rashid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/080.jpg'),
rarity: 80,
    score: 80,
    text: 'Yara Haddad',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/081.jpg'),
rarity: 81,
    score: 81,
    text: 'Leonardo Russo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Crazy Eagle',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/082.jpg'),
rarity: 82,
    score: 82,
    text: 'Beatriz Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Danger Dancer',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/083.jpg'),
rarity: 83,
    score: 83,
    text: 'Zara Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Fearless Unicorn',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/084.jpg'),
rarity: 84,
    score: 84,
    text: 'Carmen Rodriguez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Brown Lightning',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/085.jpg'),
rarity: 85,
    score: 85,
    text: 'Amine El-Khoury',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/086.jpg'),
rarity: 86,
    score: 86,
    text: 'Lucas Blanc',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Neon Hunter',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/087.jpg'),
rarity: 87,
    score: 87,
    text: 'Vanya Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Dizzy Wolf',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/088.jpg'),
rarity: 88,
    score: 88,
    text: 'Nadia Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Night Trapper',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/089.jpg'),
rarity: 89,
    score: 89,
    text: 'Simon Schneider',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'All Thumbs',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/090.jpg'),
rarity: 90,
    score: 90,
    text: 'Dina Sayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/091.jpg'),
rarity: 91,
    score: 91,
    text: 'Jorge Diaz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'One eyed',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/092.jpg'),
rarity: 92,
    score: 92,
    text: 'Aya Yamamoto',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Curious Hamster',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/093.jpg'),
rarity: 93,
    score: 93,
    text: 'Fatoumata Keita',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/094.jpg'),
rarity: 94,
    score: 94,
    text: 'Leif Johansen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Crazy Eagle',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/095.jpg'),
rarity: 95,
    score: 95,
    text: 'Daniela Souza',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/096.jpg'),
rarity: 96,
    score: 96,
    text: 'Sung Kim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Fearless Unicorn',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/097.jpg'),
rarity: 97,
    score: 97,
    text: 'Juan Pablo Morales',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brown Lightning',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/098.jpg'),
rarity: 98,
    score: 98,
    text: 'Sophia Mendez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Visible Ghost',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/099.jpg'),
rarity: 99,
    score: 99,
    text: 'Ahmed Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Neon Hunter',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/100.jpg'),
rarity: 100,
    score: 100,
    text: 'Valentina Ferrari',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Dizzy Wolf',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/101.jpg'),
rarity: 101,
    score: 101,
    text: 'Tanya Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Night Trapper',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/102.jpg'),
rarity: 102,
    score: 102,
    text: 'Erik Nilsson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'All Thumbs',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/103.jpg'),
rarity: 103,
    score: 103,
    text: 'Helena Popescu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Lopside Sack',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/104.jpg'),
rarity: 104,
    score: 104,
    text: 'Santiago Ruiz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'One eyed',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/105.jpg'),
rarity: 105,
    score: 105,
    text: 'Maria Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Curious Hamster',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/106.jpg'),
rarity: 106,
    score: 106,
    text: 'Minh Nguyen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brave Lizard',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/107.jpg'),
rarity: 107,
    score: 107,
    text: 'Isabel Martinez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Crazy Eagle',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/108.jpg'),
rarity: 108,
    score: 108,
    text: 'Matteo Bianchi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Loony',
    Codename: 'Danger Dancer',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/109.jpg'),
rarity: 109,
    score: 109,
    text: 'Youssef Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Fearless Unicorn',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/110.jpg'),
rarity: 110,
    score: 110,
    text: 'Javier Morales',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Linda',
    Codename: 'Brown Lightning',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/111.jpg'),
rarity: 111,
    score: 111,
    text: 'Lucia Rodriguez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Visible Ghost',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/112.jpg'),
rarity: 112,
    score: 112,
    text: 'David Brown',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Neon Hunter',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/113.jpg'),
rarity: 113,
    score: 113,
    text: 'Mikhail Smirnov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Dizzy Wolf',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/114.jpg'),
rarity: 114,
    score: 114,
    text: 'Ayla Yilmaz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Night Trapper',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/115.jpg'),
rarity: 115,
    score: 115,
    text: 'Chiara Esposito',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'All Thumbs',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/116.jpg'),
rarity: 116,
    score: 116,
    text: 'Gustavo Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Lopside Sack',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/117.jpg'),
rarity: 117,
    score: 117,
    text: 'Katya Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'One eyed',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/118.jpg'),
rarity: 118,
    score: 118,
    text: 'Kofi Mensah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Loony',
    Codename: 'Curious Hamster',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/119.jpg'),
rarity: 119,
    score: 119,
    text: 'Katerina Petrovic',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brave Lizard',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/120.jpg'),
rarity: 120,
    score: 120,
    text: 'Elif Demir',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Linda',
    Codename: 'Crazy Eagle',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/121.jpg'),
rarity: 121,
    score: 121,
    text: 'Faisal Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/122.jpg'),
rarity: 122,
    score: 122,
    text: 'Eva Novak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Fearless Unicorn',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/123.jpg'),
rarity: 123,
    score: 123,
    text: 'Yasmine Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/124.jpg'),
rarity: 124,
    score: 124,
    text: 'Antonio Rojas',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Linda',
    Codename: 'Visible Ghost',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/125.jpg'),
rarity: 125,
    score: 125,
    text: 'Jenna Lee',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Neon Hunter',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/126.jpg'),
rarity: 126,
    score: 126,
    text: 'Rashid Al-Farsi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/127.jpg'),
rarity: 127,
    score: 127,
    text: 'Edoardo Greco',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/128.jpg'),
rarity: 128,
    score: 128,
    text: 'Sofia Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'All Thumbs',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/129.jpg'),
rarity: 129,
    score: 129,
    text: 'Mateo Hernandez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/130.jpg'),
rarity: 130,
    score: 130,
    text: 'Ali Reza',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'One eyed',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/131.jpg'),
rarity: 131,
    score: 131,
    text: 'Hanna Andersson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Curious Hamster',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/132.jpg'),
rarity: 132,
    score: 132,
    text: 'Manuel Oliveira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/133.jpg'),
rarity: 133,
    score: 133,
    text: 'Hassan Farouk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/134.jpg'),
rarity: 134,
    score: 134,
    text: 'Erika Müller',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/135.jpg'),
rarity: 135,
    score: 135,
    text: 'Mustafa Mohamed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/136.jpg'),
rarity: 136,
    score: 136,
    text: 'Akash Patel',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/137.jpg'),
rarity: 137,
    score: 137,
    text: 'Yuki Nakamura',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/138.jpg'),
rarity: 138,
    score: 138,
    text: 'Clara Souza',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/139.jpg'),
rarity: 139,
    score: 139,
    text: 'Hassan Abdi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/140.jpg'),
rarity: 140,
    score: 140,
    text: 'Rami Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/141.jpg'),
rarity: 141,
    score: 141,
    text: 'Nina Romanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/142.jpg'),
rarity: 142,
    score: 142,
    text: 'Cecilia Fernandez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/143.jpg'),
rarity: 143,
    score: 143,
    text: 'Karim Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/144.jpg'),
rarity: 144,
    score: 144,
    text: 'Tina Chang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/145.jpg'),
rarity: 145,
    score: 145,
    text: 'Yusuf Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/146.jpg'),
rarity: 146,
    score: 146,
    text: 'Ingrid Jensen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/147.jpg'),
rarity: 147,
    score: 147,
    text: 'Josefa Rodriguez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/148.jpg'),
rarity: 148,
    score: 148,
    text: 'Min Ho',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/149.jpg'),
rarity: 149,
    score: 149,
    text: 'Vladimir Pavlov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/150.jpg'),
rarity: 150,
    score: 150,
    text: 'Marta Nowak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/151.jpg'),
rarity: 151,
    score: 151,
    text: 'Mohammed Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Neon Hunter',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/152.jpg'),
rarity: 152,
    score: 152,
    text: 'Claudia Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Dizzy Wolf',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/153.jpg'),
rarity: 153,
    score: 153,
    text: 'Aziz Benali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Night Trapper',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/154.jpg'),
rarity: 154,
    score: 154,
    text: 'Bianca Ferreira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'All Thumbs',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/155.jpg'),
rarity: 155,
    score: 155,
    text: 'Chen Li',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Lopside Sack',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/156.jpg'),
rarity: 156,
    score: 156,
    text: 'Samira Al-Hadi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'One eyed',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/157.jpg'),
rarity: 157,
    score: 157,
    text: 'Degen Poet',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Curious Hamster',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/158.jpg'),
rarity: 158,
    score: 158,
    text: 'Irina Fedorova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Brave Lizard',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/159.jpg'),
rarity: 159,
    score: 159,
    text: 'Gustavo Ramirez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Crazy Eagle',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/160.jpg'),
rarity: 160,
    score: 160,
    text: 'Zara Yusuf',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Danger Dancer',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/161.jpg'),
rarity: 161,
    score: 161,
    text: 'Santiago Martin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Fearless Unicorn',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/162.jpg'),
rarity: 162,
    score: 162,
    text: 'Akram El-Amin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brown Lightning',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/163.jpg'),
rarity: 163,
    score: 163,
    text: 'Evelyn Smith',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Visible Ghost',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/164.jpg'),
rarity: 164,
    score: 164,
    text: 'Anastasia Kuznetsova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Neon Hunter',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/165.jpg'),
rarity: 165,
    score: 165,
    text: 'Andrés Pérez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Dizzy Wolf',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/166.jpg'),
rarity: 166,
    score: 166,
    text: 'Omar Shaheen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Night Trapper',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/167.jpg'),
rarity: 167,
    score: 167,
    text: 'Chloe Dubois',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'All Thumbs',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/168.jpg'),
rarity: 168,
    score: 168,
    text: 'Sara Kim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Lopside Sack',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/169.jpg'),
rarity: 169,
    score: 169,
    text: 'Marco Pires',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'One eyed',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/170.jpg'),
rarity: 170,
    score: 170,
    text: 'Emina Ibric',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Curious Hamster',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/171.jpg'),
rarity: 171,
    score: 171,
    text: 'Adelina Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Brave Lizard',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/172.jpg'),
rarity: 172,
    score: 172,
    text: 'Max Johnson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Crazy Eagle',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/173.jpg'),
rarity: 173,
    score: 173,
    text: 'Rashid El-Amin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Danger Dancer',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/174.jpg'),
rarity: 174,
    score: 174,
    text: 'Francesco Ricci',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Fearless Unicorn',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/175.jpg'),
rarity: 175,
    score: 175,
    text: 'Ibrahim Osman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brown Lightning',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/176.jpg'),
rarity: 176,
    score: 176,
    text: 'Diana Popescu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Visible Ghost',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/177.jpg'),
rarity: 177,
    score: 177,
    text: 'Jun Wang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Neon Hunter',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/178.jpg'),
rarity: 178,
    score: 178,
    text: 'Livia Ribeiro',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Dizzy Wolf',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/179.jpg'),
rarity: 179,
    score: 179,
    text: 'Mariam Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Night Trapper',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/180.jpg'),
rarity: 180,
    score: 180,
    text: 'Adam O’Connor',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'All Thumbs',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/181.jpg'),
rarity: 181,
    score: 181,
    text: 'Ji-Young Park',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Lopside Sack',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/182.jpg'),
rarity: 182,
    score: 182,
    text: 'Alexis Taylor',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'One eyed',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/183.jpg'),
rarity: 183,
    score: 183,
    text: 'Tariq Malik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Curious Hamster',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/184.jpg'),
rarity: 184,
    score: 184,
    text: 'Gabrielle Martin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Brave Lizard',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/185.jpg'),
rarity: 185,
    score: 185,
    text: 'Mateo Fernandez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Crazy Eagle',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/186.jpg'),
rarity: 186,
    score: 186,
    text: 'Maya Chen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Danger Dancer',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/187.jpg'),
rarity: 187,
    score: 187,
    text: 'Leif Eriksson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Fearless Unicorn',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/188.jpg'),
rarity: 188,
    score: 188,
    text: 'Carlos Nascimento',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Brown Lightning',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/189.jpg'),
rarity: 189,
    score: 189,
    text: 'Sabine Meier',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Visible Ghost',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/190.jpg'),
rarity: 190,
    score: 190,
    text: 'Noura Al-Majid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Neon Hunter',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/191.jpg'),
rarity: 191,
    score: 191,
    text: 'Elena Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Dizzy Wolf',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/192.jpg'),
rarity: 192,
    score: 192,
    text: 'Lorenzo Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Night Trapper',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/193.jpg'),
rarity: 193,
    score: 193,
    text: 'Kofi Asante',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'All Thumbs',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/194.jpg'),
rarity: 194,
    score: 194,
    text: 'Yuki Sato',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Lopside Sack',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/195.jpg'),
rarity: 195,
    score: 195,
    text: 'Tatyana Sokolov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'One eyed',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/196.jpg'),
rarity: 196,
    score: 196,
    text: 'Omar Al-Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Curious Hamster',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/197.jpg'),
rarity: 197,
    score: 197,
    text: 'Ana Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brave Lizard',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/198.jpg'),
rarity: 198,
    score: 198,
    text: 'Isabel Torres',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Crazy Eagle',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/199.jpg'),
rarity: 199,
    score: 199,
    text: 'Timur Karimov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Danger Dancer',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/200.jpg'),
rarity: 200,
    score: 200,
    text: 'Tatiana Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Fearless Unicorn',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/201.jpg'),
rarity: 201,
    score: 201,
    text: 'Lina Müller',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Brown Lightning',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/202.jpg'),
rarity: 202,
    score: 202,
    text: 'Mustafa El-Sayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Visible Ghost',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/203.jpg'),
rarity: 203,
    score: 203,
    text: 'Alejandro Diaz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Neon Hunter',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/204.jpg'),
rarity: 204,
    score: 204,
    text: 'Shiori Nakamura',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Dizzy Wolf',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/205.jpg'),
rarity: 205,
    score: 205,
    text: 'Hassan Abdallah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Night Trapper',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/206.jpg'),
rarity: 206,
    score: 206,
    text: 'Clara Alves',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'All Thumbs',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/207.jpg'),
rarity: 207,
    score: 207,
    text: 'Mahmoud Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Lopside Sack',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/208.jpg'),
rarity: 208,
    score: 208,
    text: 'Viktor Kozlov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'One eyed',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/209.jpg'),
rarity: 209,
    score: 209,
    text: 'Layla Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Curious Hamster',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/210.jpg'),
rarity: 210,
    score: 210,
    text: 'Vincent Gagnon',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brave Lizard',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/211.jpg'),
rarity: 211,
    score: 211,
    text: 'Paola Santoro',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Crazy Eagle',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/212.jpg'),
rarity: 212,
    score: 212,
    text: 'Aziz Hakimi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Danger Dancer',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/213.jpg'),
rarity: 213,
    score: 213,
    text: 'Kim Lê',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Fearless Unicorn',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/214.jpg'),
rarity: 214,
    score: 214,
    text: 'Michael Green',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Brown Lightning',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/215.jpg'),
rarity: 215,
    score: 215,
    text: 'Karolina Jankowski',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Visible Ghost',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/216.jpg'),
rarity: 216,
    score: 216,
    text: 'Tamer Abu-Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Neon Hunter',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/217.jpg'),
rarity: 217,
    score: 217,
    text: 'Sophia Evans',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Dizzy Wolf',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/218.jpg'),
rarity: 218,
    score: 218,
    text: 'Adelina Kovac',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Night Trapper',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/219.jpg'),
rarity: 219,
    score: 219,
    text: 'Ali Al-Faraj',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'All Thumbs',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/220.jpg'),
rarity: 220,
    score: 220,
    text: 'Amina Yusuf',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Lopside Sack',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/221.jpg'),
rarity: 221,
    score: 221,
    text: 'Giulia Bianchi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'One eyed',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/222.jpg'),
rarity: 222,
    score: 222,
    text: 'Sara Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/223.jpg'),
rarity: 223,
    score: 223,
    text: 'Samir Rahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brave Lizard',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/224.jpg'),
rarity: 224,
    score: 224,
    text: 'Renata Russo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Crazy Eagle',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/225.jpg'),
rarity: 225,
    score: 225,
    text: 'Hans Schneider',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/226.jpg'),
rarity: 226,
    score: 226,
    text: 'Ahmed Bakr',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Fearless Unicorn',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/227.jpg'),
rarity: 227,
    score: 227,
    text: 'Sophia Walker',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/228.jpg'),
rarity: 228,
    score: 228,
    text: 'Sayed Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Visible Ghost',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/229.jpg'),
rarity: 229,
    score: 229,
    text: 'Nina Popov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Neon Hunter',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/230.jpg'),
rarity: 230,
    score: 230,
    text: 'Jorge Ribeiro',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Dizzy Wolf',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/231.jpg'),
rarity: 231,
    score: 231,
    text: 'Yasmin El-Sayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Night Trapper',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/232.jpg'),
rarity: 232,
    score: 232,
    text: 'Mikhail Romanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/233.jpg'),
rarity: 233,
    score: 233,
    text: 'Yara Al-Khalifa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/234.jpg'),
rarity: 234,
    score: 234,
    text: 'Ismail Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'One eyed',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/235.jpg'),
rarity: 235,
    score: 235,
    text: 'Erik Karlsson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Curious Hamster',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/236.jpg'),
rarity: 236,
    score: 236,
    text: 'Ines Fernández',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/237.jpg'),
rarity: 237,
    score: 237,
    text: 'Juan Garcia',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/238.jpg'),
rarity: 238,
    score: 238,
    text: 'Zhen Li',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Danger Dancer',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/239.jpg'),
rarity: 239,
    score: 239,
    text: 'Nathalie Dubois',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Fearless Unicorn',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/240.jpg'),
rarity: 240,
    score: 240,
    text: 'Alina Popescu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Brown Lightning',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/241.jpg'),
rarity: 241,
    score: 241,
    text: 'Diego Morales',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Visible Ghost',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/242.jpg'),
rarity: 242,
    score: 242,
    text: 'Zara Mohamed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Neon Hunter',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/243.jpg'),
rarity: 243,
    score: 243,
    text: 'Manuel Santos',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Dizzy Wolf',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/244.jpg'),
rarity: 244,
    score: 244,
    text: 'Alma Abbas',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Night Trapper',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/245.jpg'),
rarity: 245,
    score: 245,
    text: 'Rui Wang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'All Thumbs',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/246.jpg'),
rarity: 246,
    score: 246,
    text: 'Amal El-Sayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Lopside Sack',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/247.jpg'),
rarity: 247,
    score: 247,
    text: 'Oleg Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'One eyed',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/248.jpg'),
rarity: 248,
    score: 248,
    text: 'Rashida Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Curious Hamster',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/249.jpg'),
rarity: 249,
    score: 249,
    text: 'Carlos Mendes',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brave Lizard',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/250.jpg'),
rarity: 250,
    score: 250,
    text: 'Farah Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Crazy Eagle',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/251.jpg'),
rarity: 251,
    score: 251,
    text: 'Konstantin Pavlov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Danger Dancer',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/252.jpg'),
rarity: 252,
    score: 252,
    text: 'Mona Al-Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Fearless Unicorn',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/253.jpg'),
rarity: 253,
    score: 253,
    text: 'Henry Williams',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brown Lightning',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/254.jpg'),
rarity: 254,
    score: 254,
    text: 'Nadia Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Visible Ghost',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/255.jpg'),
rarity: 255,
    score: 255,
    text: 'Enrique Mendez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Neon Hunter',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/256.jpg'),
rarity: 256,
    score: 256,
    text: 'Sophia Martins',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Dizzy Wolf',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/257.jpg'),
rarity: 257,
    score: 257,
    text: 'Faisal Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Night Trapper',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/258.jpg'),
rarity: 258,
    score: 258,
    text: 'Lara Sokolov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/259.jpg'),
rarity: 259,
    score: 259,
    text: 'Akram Aziz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/260.jpg'),
rarity: 260,
    score: 260,
    text: 'Renata Novak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'One eyed',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/261.jpg'),
rarity: 261,
    score: 261,
    text: 'Haruto Nakamura',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Curious Hamster',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/262.jpg'),
rarity: 262,
    score: 262,
    text: 'Maria Lopez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/263.jpg'),
rarity: 263,
    score: 263,
    text: 'Samir Aziz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/264.jpg'),
rarity: 264,
    score: 264,
    text: 'Ivy Thompson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/265.jpg'),
rarity: 265,
    score: 265,
    text: 'Reem Abu-Khalid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'Fearless Unicorn',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/266.jpg'),
rarity: 266,
    score: 266,
    text: 'Liu Zhi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brown Lightning',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/267.jpg'),
rarity: 267,
    score: 267,
    text: 'Lars Lund',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Visible Ghost',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/268.jpg'),
rarity: 268,
    score: 268,
    text: 'Luciana Mendez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/269.jpg'),
rarity: 269,
    score: 269,
    text: 'Mohammed Abbas',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Dizzy Wolf',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/270.jpg'),
rarity: 270,
    score: 270,
    text: 'Mina Kim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/271.jpg'),
rarity: 271,
    score: 271,
    text: 'Nikolay Petrov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/272.jpg'),
rarity: 272,
    score: 272,
    text: 'Hana Abadi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/273.jpg'),
rarity: 273,
    score: 273,
    text: 'Thomas Brown',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/274.jpg'),
rarity: 274,
    score: 274,
    text: 'Mustafa Fahmy',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/275.jpg'),
rarity: 275,
    score: 275,
    text: 'Yara Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/276.jpg'),
rarity: 276,
    score: 276,
    text: 'Ahmed Mansour',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Crazy Eagle',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/277.jpg'),
rarity: 277,
    score: 277,
    text: 'Sophia Garcia',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/278.jpg'),
rarity: 278,
    score: 278,
    text: 'Amir Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/279.jpg'),
rarity: 279,
    score: 279,
    text: 'Mona Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/280.jpg'),
rarity: 280,
    score: 280,
    text: 'Ewa Kowalska',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/281.jpg'),
rarity: 281,
    score: 281,
    text: 'Leila Al-Rashid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/282.jpg'),
rarity: 282,
    score: 282,
    text: 'Carlos Fernandez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/283.jpg'),
rarity: 283,
    score: 283,
    text: 'Jia Zhang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/284.jpg'),
rarity: 284,
    score: 284,
    text: 'Adelina Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/285.jpg'),
rarity: 285,
    score: 285,
    text: 'William Taylor',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/286.jpg'),
rarity: 286,
    score: 286,
    text: 'Aisha Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/287.jpg'),
rarity: 287,
    score: 287,
    text: 'Federico De Luca',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/288.jpg'),
rarity: 288,
    score: 288,
    text: 'Zara Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/289.jpg'),
rarity: 289,
    score: 289,
    text: 'Yuri Volkov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/290.jpg'),
rarity: 290,
    score: 290,
    text: 'Carmen Ramirez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/291.jpg'),
rarity: 291,
    score: 291,
    text: 'Khaled El-Sayed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/292.jpg'),
rarity: 292,
    score: 292,
    text: 'Natalia Morales',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/293.jpg'),
rarity: 293,
    score: 293,
    text: 'Niko Korhonen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/294.jpg'),
rarity: 294,
    score: 294,
    text: 'Tatyana Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/295.jpg'),
rarity: 295,
    score: 295,
    text: 'Nina Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/296.jpg'),
rarity: 296,
    score: 296,
    text: 'Tariq Hussain',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/297.jpg'),
rarity: 297,
    score: 297,
    text: 'Alexandra Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/298.jpg'),
rarity: 298,
    score: 298,
    text: 'Chen Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/299.jpg'),
rarity: 299,
    score: 299,
    text: 'Frida Eriksson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/300.jpg'),
rarity: 300,
    score: 300,
    text: 'Mariana Silva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/301.jpg'),
rarity: 301,
    score: 301,
    text: 'Javed Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/302.jpg'),
rarity: 302,
    score: 302,
    text: 'Angela Marino',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/303.jpg'),
rarity: 303,
    score: 303,
    text: 'Timur Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/304.jpg'),
rarity: 304,
    score: 304,
    text: 'Fatima Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/305.jpg'),
rarity: 305,
    score: 305,
    text: 'Carlos González',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/306.jpg'),
rarity: 306,
    score: 306,
    text: 'Amina Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/307.jpg'),
rarity: 307,
    score: 307,
    text: 'Jae Kim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/308.jpg'),
rarity: 308,
    score: 308,
    text: 'Dina Mohamed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Dizzy Wolf',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/309.jpg'),
rarity: 309,
    score: 309,
    text: 'Ahmed Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/310.jpg'),
rarity: 310,
    score: 310,
    text: 'Gabriella Gomez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/311.jpg'),
rarity: 311,
    score: 311,
    text: 'Ivan Kuznetsov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/312.jpg'),
rarity: 312,
    score: 312,
    text: 'Elena Smirnova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/313.jpg'),
rarity: 313,
    score: 313,
    text: 'Mohammed Al-Farsi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/314.jpg'),
rarity: 314,
    score: 314,
    text: 'Violeta Ramirez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/315.jpg'),
rarity: 315,
    score: 315,
    text: 'Sayed Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Crazy Eagle',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/316.jpg'),
rarity: 316,
    score: 316,
    text: 'Tomás Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/317.jpg'),
rarity: 317,
    score: 317,
    text: 'Alya Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/318.jpg'),
rarity: 318,
    score: 318,
    text: 'Mikhail Petrov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/319.jpg'),
rarity: 319,
    score: 319,
    text: 'Ivy Brown',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/320.jpg'),
rarity: 320,
    score: 320,
    text: 'Hassan Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/321.jpg'),
rarity: 321,
    score: 321,
    text: 'Nina Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/322.jpg'),
rarity: 322,
    score: 322,
    text: 'Jin Huang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/323.jpg'),
rarity: 323,
    score: 323,
    text: 'Rashid Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/324.jpg'),
rarity: 324,
    score: 324,
    text: 'Laura Müller',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/325.jpg'),
rarity: 325,
    score: 325,
    text: 'Ahmed Khalid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/326.jpg'),
rarity: 326,
    score: 326,
    text: 'Jana El-Masry',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/327.jpg'),
rarity: 327,
    score: 327,
    text: 'Vincent Martin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/328.jpg'),
rarity: 328,
    score: 328,
    text: 'Mateus Ferreira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/329.jpg'),
rarity: 329,
    score: 329,
    text: 'Nadia Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/330.jpg'),
rarity: 330,
    score: 330,
    text: 'Yara Hamdi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/331.jpg'),
rarity: 331,
    score: 331,
    text: 'Igor Pavlov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/332.jpg'),
rarity: 332,
    score: 332,
    text: 'Alexis Dubois',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/333.jpg'),
rarity: 333,
    score: 333,
    text: 'Nina Popescu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/334.jpg'),
rarity: 334,
    score: 334,
    text: 'Diego Rivera',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/335.jpg'),
rarity: 335,
    score: 335,
    text: 'Hassan Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/336.jpg'),
rarity: 336,
    score: 336,
    text: 'Emily Anderson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/337.jpg'),
rarity: 337,
    score: 337,
    text: 'Reza Karim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/338.jpg'),
rarity: 338,
    score: 338,
    text: 'Sophia Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'One eyed',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/339.jpg'),
rarity: 339,
    score: 339,
    text: 'Marco Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Curious Hamster',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/340.jpg'),
rarity: 340,
    score: 340,
    text: 'Amira Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/341.jpg'),
rarity: 341,
    score: 341,
    text: 'Hassan Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/342.jpg'),
rarity: 342,
    score: 342,
    text: 'Natalia Jovanovic',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/343.jpg'),
rarity: 343,
    score: 343,
    text: 'John Smith',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Fearless Unicorn',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/344.jpg'),
rarity: 344,
    score: 344,
    text: 'Mira Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brown Lightning',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/345.jpg'),
rarity: 345,
    score: 345,
    text: 'Ahmed Omar',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Visible Ghost',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/346.jpg'),
rarity: 346,
    score: 346,
    text: 'Natalia Romanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/347.jpg'),
rarity: 347,
    score: 347,
    text: 'Javier Morales',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Linda',
    Codename: 'Brown Lightning',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/348.jpg'),
rarity: 348,
    score: 348,
    text: 'Mei Ling',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/349.jpg'),
rarity: 349,
    score: 349,
    text: 'Ali Hamid',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/350.jpg'),
rarity: 350,
    score: 350,
    text: 'Yelena Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/351.jpg'),
rarity: 351,
    score: 351,
    text: 'Ivan Sokolov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/352.jpg'),
rarity: 352,
    score: 352,
    text: 'Hassan Shaheen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/353.jpg'),
rarity: 353,
    score: 353,
    text: 'Amina Farah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/354.jpg'),
rarity: 354,
    score: 354,
    text: 'Dmitri Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Crazy Eagle',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/355.jpg'),
rarity: 355,
    score: 355,
    text: 'Nina Rossi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/356.jpg'),
rarity: 356,
    score: 356,
    text: 'Carlos Martinez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/357.jpg'),
rarity: 357,
    score: 357,
    text: 'Yasmin Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/358.jpg'),
rarity: 358,
    score: 358,
    text: 'Minh Tran',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/359.jpg'),
rarity: 359,
    score: 359,
    text: 'Alicia Mendoza',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/360.jpg'),
rarity: 360,
    score: 360,
    text: 'Yusra Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/361.jpg'),
rarity: 361,
    score: 361,
    text: 'Sven Johansson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/362.jpg'),
rarity: 362,
    score: 362,
    text: 'Larissa Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/363.jpg'),
rarity: 363,
    score: 363,
    text: 'Rami Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/364.jpg'),
rarity: 364,
    score: 364,
    text: 'Marta Silva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/365.jpg'),
rarity: 365,
    score: 365,
    text: 'Osman Abdullah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/366.jpg'),
rarity: 366,
    score: 366,
    text: 'Emma Taylor',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/367.jpg'),
rarity: 367,
    score: 367,
    text: 'Mohammed Hasan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/368.jpg'),
rarity: 368,
    score: 368,
    text: 'Marta Ferreira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/369.jpg'),
rarity: 369,
    score: 369,
    text: 'Nadia Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/370.jpg'),
rarity: 370,
    score: 370,
    text: 'Leif Eriksen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/371.jpg'),
rarity: 371,
    score: 371,
    text: 'Yana Romanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/372.jpg'),
rarity: 372,
    score: 372,
    text: 'Omar Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/373.jpg'),
rarity: 373,
    score: 373,
    text: 'Isabel Ortiz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/374.jpg'),
rarity: 374,
    score: 374,
    text: 'Ayesha Khan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/375.jpg'),
rarity: 375,
    score: 375,
    text: 'Fouad Abdallah',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/376.jpg'),
rarity: 376,
    score: 376,
    text: 'Khalid Ibrahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/377.jpg'),
rarity: 377,
    score: 377,
    text: 'Angela Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/379.jpg'),
rarity: 379,
    score: 379,
    text: 'Yasmina El-Farouk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/380.jpg'),
rarity: 380,
    score: 380,
    text: 'Fatima Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/381.jpg'),
rarity: 381,
    score: 381,
    text: 'Hiro Tanaka',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/382.jpg'),
rarity: 382,
    score: 382,
    text: 'Gabriel Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/383.jpg'),
rarity: 383,
    score: 383,
    text: 'Lucia Hernandez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/384.jpg'),
rarity: 384,
    score: 384,
    text: 'Rashida Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/385.jpg'),
rarity: 385,
    score: 385,
    text: 'Rui Chen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/386.jpg'),
rarity: 386,
    score: 386,
    text: 'Juan Martinez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Dizzy Wolf',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/387.jpg'),
rarity: 387,
    score: 387,
    text: 'Zoya Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/388.jpg'),
rarity: 388,
    score: 388,
    text: 'Amina Saad',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/389.jpg'),
rarity: 389,
    score: 389,
    text: 'Pavel Sokolov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/390.jpg'),
rarity: 390,
    score: 390,
    text: 'Mariana Sousa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/391.jpg'),
rarity: 391,
    score: 391,
    text: 'Kamal Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/392.jpg'),
rarity: 392,
    score: 392,
    text: 'Ana Costa',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/393.jpg'),
rarity: 393,
    score: 393,
    text: 'Mikhail Ivanov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Crazy Eagle',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/394.jpg'),
rarity: 394,
    score: 394,
    text: 'Olga Kuznetsova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Danger Dancer',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/395.jpg'),
rarity: 395,
    score: 395,
    text: 'Said Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Fearless Unicorn',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/396.jpg'),
rarity: 396,
    score: 396,
    text: 'Javier Martinez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Brown Lightning',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/397.jpg'),
rarity: 397,
    score: 397,
    text: 'Mona Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/398.jpg'),
rarity: 398,
    score: 398,
    text: 'Alina Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Neon Hunter',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/399.jpg'),
rarity: 399,
    score: 399,
    text: 'Zhang Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Dizzy Wolf',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/400.jpg'),
rarity: 400,
    score: 400,
    text: 'Renata Pereira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Night Trapper',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/401.jpg'),
rarity: 401,
    score: 401,
    text: 'Yara Khalil',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'All Thumbs',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/402.jpg'),
rarity: 402,
    score: 402,
    text: 'Jin Li',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Lopside Sack',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/403.jpg'),
rarity: 403,
    score: 403,
    text: 'Reem Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'One eyed',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/404.jpg'),
rarity: 404,
    score: 404,
    text: 'Rachid Ben Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Curious Hamster',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/405.jpg'),
rarity: 405,
    score: 405,
    text: 'Petra Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brave Lizard',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/406.jpg'),
rarity: 406,
    score: 406,
    text: 'Mohammed Aziz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Crazy Eagle',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/407.jpg'),
rarity: 407,
    score: 407,
    text: 'Laura Silva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Danger Dancer',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/408.jpg'),
rarity: 408,
    score: 408,
    text: 'Manuel Santos',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Dizzy Wolf',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/409.jpg'),
rarity: 409,
    score: 409,
    text: 'Jana Rahman',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brown Lightning',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/410.jpg'),
rarity: 410,
    score: 410,
    text: 'Mustafa Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Visible Ghost',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/411.jpg'),
rarity: 411,
    score: 411,
    text: 'Clara Novak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Neon Hunter',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/412.jpg'),
rarity: 412,
    score: 412,
    text: 'Said Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Dizzy Wolf',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/413.jpg'),
rarity: 413,
    score: 413,
    text: 'Rosa Martinez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Night Trapper',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/414.jpg'),
rarity: 414,
    score: 414,
    text: 'Anastasia Petrova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/415.jpg'),
rarity: 415,
    score: 415,
    text: 'Ravi Patel',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/416.jpg'),
rarity: 416,
    score: 416,
    text: 'Sarah Brown',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'One eyed',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/417.jpg'),
rarity: 417,
    score: 417,
    text: 'Yara Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Curious Hamster',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/418.jpg'),
rarity: 418,
    score: 418,
    text: 'Leif Svensson',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/419.jpg'),
rarity: 419,
    score: 419,
    text: 'Nadia Rahim',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/420.jpg'),
rarity: 420,
    score: 420,
    text: 'Vladimir Petrov',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/421.jpg'),
rarity: 421,
    score: 421,
    text: 'Sara Ali',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'Fearless Unicorn',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/422.jpg'),
rarity: 422,
    score: 422,
    text: 'Min Ho',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/423.jpg'),
rarity: 423,
    score: 423,
    text: 'Tariq Ahmad',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Visible Ghost',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/424.jpg'),
rarity: 424,
    score: 424,
    text: 'Fatima Al-Hassan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Neon Hunter',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/425.jpg'),
rarity: 425,
    score: 425,
    text: 'Lars Nielsen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Dizzy Wolf',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/426.jpg'),
rarity: 426,
    score: 426,
    text: 'Maria Ferreira',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Night Trapper',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/427.jpg'),
rarity: 427,
    score: 427,
    text: 'Rashid Ahmed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'All Thumbs',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/428.jpg'),
rarity: 428,
    score: 428,
    text: 'Mia Park',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Lopside Sack',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/429.jpg'),
rarity: 429,
    score: 429,
    text: 'Xinyi Zhang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'One eyed',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/430.jpg'),
rarity: 430,
    score: 430,
    text: 'Zara Mohammed',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Curious Hamster',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/431.jpg'),
rarity: 431,
    score: 431,
    text: 'Gabriel Mendes',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brave Lizard',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/432.jpg'),
rarity: 432,
    score: 432,
    text: 'Alexandra Ivanova',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/433.jpg'),
rarity: 433,
    score: 433,
    text: 'Omar Hussein',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Danger Dancer',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/434.jpg'),
rarity: 434,
    score: 434,
    text: 'Sofia Lopez',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/435.jpg'),
rarity: 435,
    score: 435,
    text: 'Carlos Silva',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/436.jpg'),
rarity: 436,
    score: 436,
    text: 'Ming Cheng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/437.jpg'),
rarity: 437,
    score: 437,
    text: 'Yara Aziz',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/438.jpg'),
rarity: 438,
    score: 438,
    text: 'Ahmed Youssef',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/439.jpg'),
rarity: 439,
    score: 439,
    text: 'Li Jing',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/440.jpg'),
rarity: 440,
    score: 440,
    text: 'Zhang Bo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/441.jpg'),
rarity: 441,
    score: 441,
    text: 'Wang Jun',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/442.jpg'),
rarity: 442,
    score: 442,
    text: 'Liu Yan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/443.jpg'),
rarity: 443,
    score: 443,
    text: 'Zhao Rui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/444.jpg'),
rarity: 444,
    score: 444,
    text: 'Huang Jia',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/445.jpg'),
rarity: 445,
    score: 445,
    text: 'Zhou Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/446.jpg'),
rarity: 446,
    score: 446,
    text: 'Wu Xin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/447.jpg'),
rarity: 447,
    score: 447,
    text: 'Xu Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/448.jpg'),
rarity: 448,
    score: 448,
    text: 'Sun Yan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/449.jpg'),
rarity: 449,
    score: 449,
    text: 'Ma Zi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/450.jpg'),
rarity: 450,
    score: 450,
    text: 'Guo Yu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/451.jpg'),
rarity: 451,
    score: 451,
    text: 'Lin Yue',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/452.jpg'),
rarity: 452,
    score: 452,
    text: 'Zheng Li',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/453.jpg'),
rarity: 453,
    score: 453,
    text: 'Gao Rui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/454.jpg'),
rarity: 454,
    score: 454,
    text: 'Xie Ming',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/455.jpg'),
rarity: 455,
    score: 455,
    text: 'He Qiang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/456.jpg'),
rarity: 456,
    score: 456,
    text: 'Luo Ning',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/457.jpg'),
rarity: 457,
    score: 457,
    text: 'Liang Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/458.jpg'),
rarity: 458,
    score: 458,
    text: 'Song Tian',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/459.jpg'),
rarity: 459,
    score: 459,
    text: 'Tang Hui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/460.jpg'),
rarity: 460,
    score: 460,
    text: 'Deng Rong',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/461.jpg'),
rarity: 461,
    score: 461,
    text: 'Han Yue',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/462.jpg'),
rarity: 462,
    score: 462,
    text: 'Feng Bin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/463.jpg'),
rarity: 463,
    score: 463,
    text: 'Yu Heng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Neon Hunter',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/464.jpg'),
rarity: 464,
    score: 464,
    text: 'Ren Jing',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Dizzy Wolf',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/465.jpg'),
rarity: 465,
    score: 465,
    text: 'Yao Wen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Night Trapper',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/466.jpg'),
rarity: 466,
    score: 466,
    text: 'Wang Yong',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'All Thumbs',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/467.jpg'),
rarity: 467,
    score: 467,
    text: 'Shen Jun',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Lopside Sack',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/468.jpg'),
rarity: 468,
    score: 468,
    text: 'Jiang Feng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'One eyed',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/469.jpg'),
rarity: 469,
    score: 469,
    text: 'Cui Shan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Curious Hamster',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/470.jpg'),
rarity: 470,
    score: 470,
    text: 'Gu Jin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Brave Lizard',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/471.jpg'),
rarity: 471,
    score: 471,
    text: 'Zhu Bo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Crazy Eagle',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/472.jpg'),
rarity: 472,
    score: 472,
    text: 'Wei Hui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Danger Dancer',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/473.jpg'),
rarity: 473,
    score: 473,
    text: 'Du Qing',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'Fearless Unicorn',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/474.jpg'),
rarity: 474,
    score: 474,
    text: 'Ye Ling',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brown Lightning',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/475.jpg'),
rarity: 475,
    score: 475,
    text: 'Luo Fang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Visible Ghost',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/476.jpg'),
rarity: 476,
    score: 476,
    text: 'Pan Xin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Neon Hunter',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/477.jpg'),
rarity: 477,
    score: 477,
    text: 'Ding Hua',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Dizzy Wolf',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/478.jpg'),
rarity: 478,
    score: 478,
    text: 'Shi Ran',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Night Trapper',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/479.jpg'),
rarity: 479,
    score: 479,
    text: 'Tang Jie',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'All Thumbs',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/480.jpg'),
rarity: 480,
    score: 480,
    text: 'Yu Qiang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Lopside Sack',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/481.jpg'),
rarity: 481,
    score: 481,
    text: 'Wang Feng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'One eyed',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/482.jpg'),
rarity: 482,
    score: 482,
    text: 'Xiao Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Curious Hamster',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/483.jpg'),
rarity: 483,
    score: 483,
    text: 'Xie Hui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/484.jpg'),
rarity: 484,
    score: 484,
    text: 'Deng Long',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/485.jpg'),
rarity: 485,
    score: 485,
    text: 'Mo Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/486.jpg'),
rarity: 486,
    score: 486,
    text: 'Jin Hui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/487.jpg'),
rarity: 487,
    score: 487,
    text: 'Zeng Lin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/488.jpg'),
rarity: 488,
    score: 488,
    text: 'Zou Bin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/489.jpg'),
rarity: 489,
    score: 489,
    text: 'Bao Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/490.jpg'),
rarity: 490,
    score: 490,
    text: 'Shi Liang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/491.jpg'),
rarity: 491,
    score: 491,
    text: 'Zhu Fang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/492.jpg'),
rarity: 492,
    score: 492,
    text: 'Chen Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/493.jpg'),
rarity: 493,
    score: 493,
    text: 'Lin Hong',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/494.jpg'),
rarity: 494,
    score: 494,
    text: 'Liu Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/495.jpg'),
rarity: 495,
    score: 495,
    text: 'Wu Yu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/496.jpg'),
rarity: 496,
    score: 496,
    text: 'Cheng Jun',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/497.jpg'),
rarity: 497,
    score: 497,
    text: 'Huang Wei',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/498.jpg'),
rarity: 498,
    score: 498,
    text: 'Zhou Wen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/499.jpg'),
rarity: 499,
    score: 499,
    text: 'Xu Feng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/500.jpg'),
rarity: 500,
    score: 500,
    text: 'Wei Jie',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/501.jpg'),
rarity: 501,
    score: 501,
    text: 'Feng Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Visible Ghost',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/502.jpg'),
rarity: 502,
    score: 502,
    text: 'Lu Jia',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Neon Hunter',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/503.jpg'),
rarity: 503,
    score: 503,
    text: 'Jiang Ying',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Dizzy Wolf',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/504.jpg'),
rarity: 504,
    score: 504,
    text: 'Li Han',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Night Trapper',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/505.jpg'),
rarity: 505,
    score: 505,
    text: 'Zhang Qiang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'All Thumbs',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/506.jpg'),
rarity: 506,
    score: 506,
    text: 'Wang Yue',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Lopside Sack',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/507.jpg'),
rarity: 507,
    score: 507,
    text: 'Zhao Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'One eyed',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/508.jpg'),
rarity: 508,
    score: 508,
    text: 'Zhu Ling',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Loony',
    Codename: 'Curious Hamster',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/509.jpg'),
rarity: 509,
    score: 509,
    text: 'Gao Jie',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Brave Lizard',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/510.jpg'),
rarity: 510,
    score: 510,
    text: 'Xie Hong',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Crazy Eagle',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/511.jpg'),
rarity: 511,
    score: 511,
    text: 'He Yan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Danger Dancer',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/512.jpg'),
rarity: 512,
    score: 512,
    text: 'Luo Qi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Fearless Unicorn',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/513.jpg'),
rarity: 513,
    score: 513,
    text: 'Liu Qi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Brown Lightning',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/514.jpg'),
rarity: 514,
    score: 514,
    text: 'Shen Lin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Visible Ghost',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/515.jpg'),
rarity: 515,
    score: 515,
    text: 'Yang Xi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Neon Hunter',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/516.jpg'),
rarity: 516,
    score: 516,
    text: 'Wang Xin',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Dizzy Wolf',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/517.jpg'),
rarity: 517,
    score: 517,
    text: 'Han Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Night Trapper',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/518.jpg'),
rarity: 518,
    score: 518,
    text: 'Zhou Rui',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Loony',
    Codename: 'All Thumbs',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/519.jpg'),
rarity: 519,
    score: 519,
    text: 'Wang Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Lopside Sack',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/520.jpg'),
rarity: 520,
    score: 520,
    text: 'Ma Wen',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Linda',
    Codename: 'One eyed',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/521.jpg'),
rarity: 521,
    score: 521,
    text: 'Sun Jie',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Curious Hamster',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/522.jpg'),
rarity: 522,
    score: 522,
    text: 'Chen Kang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brave Lizard',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/523.jpg'),
rarity: 523,
    score: 523,
    text: 'Xu Yu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Crazy Eagle',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/524.jpg'),
rarity: 524,
    score: 524,
    text: 'Li Jun',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Danger Dancer',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/525.jpg'),
rarity: 525,
    score: 525,
    text: 'Gao Qiang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Fearless Unicorn',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/526.jpg'),
rarity: 526,
    score: 526,
    text: 'Fan Fang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Brown Lightning',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/527.jpg'),
rarity: 527,
    score: 527,
    text: 'Zheng Bo',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Visible Ghost',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/528.jpg'),
rarity: 528,
    score: 528,
    text: 'Luo Shan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Loony',
    Codename: 'Neon Hunter',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/529.jpg'),
rarity: 529,
    score: 529,
    text: 'Zhang Qi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Dizzy Wolf',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/530.jpg'),
rarity: 530,
    score: 530,
    text: 'John Le',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Linda',
    Codename: 'Night Trapper',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/531.jpg'),
rarity: 531,
    score: 531,
    text: 'Sun Cheng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'All Thumbs',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/532.jpg'),
rarity: 532,
    score: 532,
    text: 'He Long',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Lopside Sack',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/533.jpg'),
rarity: 533,
    score: 533,
    text: 'Wang Hao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Lopside Sack',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/534.jpg'),
rarity: 534,
    score: 534,
    text: 'Chen Xuan',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/535.jpg'),
rarity: 535,
    score: 535,
    text: 'Zhao Feng',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brave Lizard',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/536.jpg'),
rarity: 536,
    score: 536,
    text: 'Hu Liang',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Crazy Eagle',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/537.jpg'),
rarity: 537,
    score: 537,
    text: 'Zhang Xi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Danger Dancer',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/538.jpg'),
rarity: 538,
    score: 538,
    text: 'Li Tao',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Fearless Unicorn',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/539.jpg'),
rarity: 539,
    score: 539,
    text: 'Amaqjuaq Tulugaak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Brown Lightning',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/540.jpg'),
rarity: 540,
    score: 540,
    text: 'Nanuq Pamiuq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Visible Ghost',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/541.jpg'),
rarity: 541,
    score: 541,
    text: 'Siku Isaroak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Neon Hunter',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/542.jpg'),
rarity: 542,
    score: 542,
    text: 'Qannik Kayuqtuq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Dizzy Wolf',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/543.jpg'),
rarity: 543,
    score: 543,
    text: 'Tulimak Ilanak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Night Trapper',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/544.jpg'),
rarity: 544,
    score: 544,
    text: 'Panik Kiggavik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'All Thumbs',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/545.jpg'),
rarity: 545,
    score: 545,
    text: 'Atanarjuat Nuviagak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Lopside Sack',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/546.jpg'),
rarity: 546,
    score: 546,
    text: 'Nasuk Umiaq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'One eyed',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/547.jpg'),
rarity: 547,
    score: 547,
    text: 'Aput Kiillinnguaq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Linda',
    Codename: 'Curious Hamster',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/548.jpg'),
rarity: 548,
    score: 548,
    text: 'Issorartuyok Arnakuagsak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brave Lizard',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/549.jpg'),
rarity: 549,
    score: 549,
    text: 'Pinga Kumaglak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Crazy Eagle',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/550.jpg'),
rarity: 550,
    score: 550,
    text: 'Tuktu Sukaq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Danger Dancer',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/551.jpg'),
rarity: 551,
    score: 551,
    text: 'Silak Kilimak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Fearless Unicorn',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/552.jpg'),
rarity: 552,
    score: 552,
    text: 'Nunataq Ittukusuk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Brown Lightning',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/553.jpg'),
rarity: 553,
    score: 553,
    text: 'Amaruq Tavvauvusi',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Visible Ghost',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/554.jpg'),
rarity: 554,
    score: 554,
    text: 'Kallik Pitsiulak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Neon Hunter',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/555.jpg'),
rarity: 555,
    score: 555,
    text: 'Taqtu Qulitalik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Loony',
    Codename: 'Dizzy Wolf',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/556.jpg'),
rarity: 556,
    score: 556,
    text: 'Nanook Siksik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Night Trapper',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/557.jpg'),
rarity: 557,
    score: 557,
    text: 'Ayu Piinnaq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Linda',
    Codename: 'All Thumbs',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/558.jpg'),
rarity: 558,
    score: 558,
    text: 'Qilak Tikaani',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Lopside Sack',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/559.jpg'),
rarity: 559,
    score: 559,
    text: 'Aklak Kunik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'One eyed',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/560.jpg'),
rarity: 560,
    score: 560,
    text: 'Arnau Aglukark',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Curious Hamster',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/561.jpg'),
rarity: 561,
    score: 561,
    text: 'Inuksuk Tulimak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Brave Lizard',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/562.jpg'),
rarity: 562,
    score: 562,
    text: 'Sivulliq Malina',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Crazy Eagle',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/563.jpg'),
rarity: 563,
    score: 563,
    text: 'Tikaani Atuat',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Danger Dancer',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/564.jpg'),
rarity: 564,
    score: 564,
    text: 'Kayuh Qamaniq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Fearless Unicorn',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/565.jpg'),
rarity: 565,
    score: 565,
    text: 'Miki Suli',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Loony',
    Codename: 'Brown Lightning',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/566.jpg'),
rarity: 566,
    score: 566,
    text: 'Kuuk Amarualik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Visible Ghost',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/567.jpg'),
rarity: 567,
    score: 567,
    text: 'Siku Inuglak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Linda',
    Codename: 'Neon Hunter',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/568.jpg'),
rarity: 568,
    score: 568,
    text: 'Pukak Tapatai',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Dizzy Wolf',
    Pastime: 'Luxury waste water connoisseur'
},
{
  path: require('./assets/569.jpg'),
rarity: 569,
    score: 569,
    text: 'Pakak Iqaluk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Night Trapper',
    Pastime: 'Whistleblowing petty Jesus'
},
{
  path: require('./assets/570.jpg'),
rarity: 570,
    score: 570,
    text: 'Sumaq Napayok',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'All Thumbs',
    Pastime: 'Learning ancient, forbidden magik'
},
{
  path: require('./assets/571.jpg'),
rarity: 571,
    score: 571,
    text: 'Tiri Aullak',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Chest Hairstylist',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Lopside Sack',
    Pastime: 'Lost souls wrestling Coach '
},
{
  path: require('./assets/572.jpg'),
rarity: 572,
    score: 572,
    text: 'Umiak Pingu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Saviour of ecosystems',
    Occupation: 'Nuclear Waste Archaeologist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'One eyed',
    Pastime: 'Indomitable proselytizer of apolitical geniuses'
},
{
  path: require('./assets/573.jpg'),
rarity: 573,
    score: 573,
    text: 'Nuka Nuliajuk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Starving artist',
    Occupation: 'Overdue Utility Bill Distributor',
    ReligiousPersuasion: 'Two-in-One',
    Codename: 'Curious Hamster',
    Pastime: 'Night emmisions thief'
},
{
  path: require('./assets/574.jpg'),
rarity: 574,
    score: 574,
    text: 'Tunerk Inutiq',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Memecoin gambler',
    Occupation: 'Uncle Kei Impersonator',
    ReligiousPersuasion: 'Roman Cathartic',
    Codename: 'Brave Lizard',
    Pastime: 'Curator of apocryphal and non-existent texts'
},
{
  path: require('./assets/575.jpg'),
rarity: 575,
    score: 575,
    text: 'Annakpok Kavik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Larping as an art collector',
    Occupation: 'Banjo dealer',
    ReligiousPersuasion: 'Loony',
    Codename: 'Crazy Eagle',
    Pastime: 'Bed bug grooming'
},
{
  path: require('./assets/576.jpg'),
rarity: 576,
    score: 576,
    text: 'Ivik Tuktu',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Creating yet another PFP',
    Occupation: 'Fudding Vibhu',
    ReligiousPersuasion: 'Leaning towards Sassy',
    Codename: 'Danger Dancer',
    Pastime: 'Catcalling Cats'
},
{
  path: require('./assets/577.jpg'),
rarity: 577,
    score: 577,
    text: 'Itigaituk Panik',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Has-been influencer',
    Occupation: '0xMQQ Intern',
    ReligiousPersuasion: 'Linda',
    Codename: 'Fearless Unicorn',
    Pastime: 'Leaning on cars in the streets'
},
{
  path: require('./assets/578.jpg'),
rarity: 578,
    score: 578,
    text: 'Siksik Nuna',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Clueless grifter',
    Occupation: 'Merkin Artisan',
    ReligiousPersuasion: 'Phallusophical',
    Codename: 'Brown Lightning',
    Pastime: 'Disposable cutlery and sauce hoarder'
},
{
  path: require('./assets/579.jpg'),
rarity: 579,
    score: 579,
    text: 'Tiglik Itigaituk',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Premature jeeting',
    Occupation: 'Bathroom Store Janitor',
    ReligiousPersuasion: 'Lost Baby',
    Codename: 'Visible Ghost',
    Pastime: 'Addicted to curtsying'
},
{
  path: require('./assets/580.jpg'),
rarity: 580,
    score: 580,
    text: 'Taktu Natar',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Annoying replyoor',
    Occupation: 'B Movie Extra',
    ReligiousPersuasion: 'Thelonious Monk',
    Codename: 'Neon Hunter',
    Pastime: 'Daydreaming impossible scenarios'
},
{
  path: require('./assets/581.jpg'),
rarity: 581,
    score: 581,
    text: 'Kanguq Miki',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Inaccurate alpha caller',
    Occupation: 'Diaper Sniffer',
    ReligiousPersuasion: 'Flavour Balls',
    Codename: 'Dizzy Wolf',
    Pastime: 'Smuggling snacks into the toilet'
},
{
  path: require('./assets/582.jpg'),
rarity: 582,
    score: 582,
    text: 'Nuliajuk Suka',
    Description: 'A curated collection of hand-drawn PFP portraits inspired by discovered, found and collected photographs',
    Web3Alignment: 'Dead-end developer',
    Occupation: 'Porno FX Artist',
    ReligiousPersuasion: 'Lazy Eyes',
    Codename: 'Night Trapper',
    Pastime: 'Luxury waste water connoisseur'
}
];

export default imageData;